<template>
  <v-switch
    class="Switch"
    :color="color || '#3c5aaa'"
    :label="label"
    v-model="localValue"
    hide-details="auto"
    density="compact"
    @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>
<script>
export default {
  name: "SwitchField",
  props: {
    modelValue: { default: null },
    label:      { type: String, default: "" },
    color:      { type: String, default: "#3c5aaa" },
  },
  emits: ["update:modelValue"],
  computed: {
    localValue: {
      get() { return this.modelValue; },
      set(val) { this.$emit("update:modelValue", val); },
    },
  },
};
</script>
<style lang="scss">
.Switch {
  .v-selection-control .v-label {
    white-space: normal;
    word-break: break-word;
    font-size: 14px;
    font-weight: 500;
  }
}
</style>